import clsx from "clsx";
import { CSSProperties } from "react";

import styles from "./ButtonSkeleton.module.scss";

type ButtonSkeletonProps = {
  className?: string;
  style?: CSSProperties;
};

export const ButtonSkeleton = ({ style, className }: ButtonSkeletonProps) => (
  <div className={clsx(className, styles.button)} style={style} />
);
